// extracted by mini-css-extract-plugin
export default {"overlay":"styles_overlay__iIVt2","content":"styles_content__SHYw6","description":"styles_description__xqPtl","icon":"styles_icon__DWLF1","closeButton":"styles_closeButton__sl5Dy"};